<template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flexc-cen-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>续期预警</el-breadcrumb-item>
      </el-breadcrumb>
      <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
          <el-option
                  v-for="item in DianList"
                  :key="item.ID"
                  :label="item.StoresName"
                  :value="item.ID">
          </el-option>
      </el-select>
    </div>
     <el-tabs v-model="activeName" @tab-click="handleClick" style="padding-top:30px">
      <el-tab-pane label="次卡预警" name="0" v-if="isCard == 1" >
        <el-form :inline="true" :model="formInline" >
            <el-form-item label="搜索：">
            <el-input size="mini" v-model="formInline.deptName" placeholder="输入姓名、手机号"></el-input>
            </el-form-item>
             <el-form-item label="">
              <el-select  size="mini" v-model="MembersType">
                      <el-option
                            v-for="item in  membersList"
                            :key="item.ID"
                            :label="item.name"
                            :value="item.ID">
                    </el-option>
              </el-select>
             </el-form-item>
            <el-form-item label="">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-alert title="" type="warning" :closable="false">
        <div style="color:black">预警值：  剩余次数 ≤ <span class="Warning">{{CardNumber}}</span> 次 或 剩余天数 ≤ <span class="Warning">{{CardDays}}</span> 天 <el-button type="text"  size="mini" class="Warning" @click="toEdit" style="margin-left:30px">设置</el-button></div>
        </el-alert>
          <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="mini" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
              <el-table-column  prop="Name" label="姓名" >
                <template slot-scope="scope">
                  <div class="flexc-cen-x">
                    <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                    <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px">{{scope.row.Name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="Phone" label="手机号"  align="center">
              </el-table-column>
              <el-table-column  prop="CardName" label="会员卡"  align="center">
              </el-table-column>
              <el-table-column  prop="syNumber" label="卡类别"  align="center">
                <template slot-scope="scope">
                    <span v-if="scope.row.CardType == 1">次卡（有期限）</span>
                    <span v-if="scope.row.CardType == 2">次卡（无限期）</span>
                    <span v-if="scope.row.CardType == 3">期限卡（不限次数）</span>
                    <span v-if="scope.row.CardType == 4">储蓄卡（无期限）</span>
                    <span v-if="scope.row.CardType == 5">期限卡（有期限）</span>
                </template>
              </el-table-column>
              <el-table-column  prop="OverdueTime" label="到期时间"  align="center">
              </el-table-column>
              <el-table-column  prop="CardNumber" label="剩余数量(次)"  align="center">
              </el-table-column>
            <el-table-column align="center" label="操作" width="500"  fixed="right" >
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" v-if="q2 == true" @click="handleDetail(scope.row)">续费</el-button>
                  <el-button size="mini" type="danger" v-if="q3 == true"  @click="handleChong(scope.row)">续费提醒</el-button>
              </template>
            </el-table-column>
          </el-table>
       <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="期限卡预警" name="1" v-if="isCard == 1">        
          <el-form :inline="true" :model="formInline" >
            <el-form-item label="搜索：">
            <el-input size="mini" v-model="formInline.deptName" placeholder="输入姓名、手机号"></el-input>
            </el-form-item>
                         <el-form-item label="">
              <el-select  size="mini" v-model="MembersType">
                      <el-option
                            v-for="item in  membersList"
                            :key="item.ID"
                            :label="item.name"
                            :value="item.ID">
                    </el-option>
              </el-select>
             </el-form-item>
            <el-form-item label="">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            
        </el-form>
        <el-alert title="" type="warning" :closable="false">
        <div style="color:black">预警值： 剩余天数 ≤ <span class="Warning">{{CardDays}}</span> 天         <el-button type="text" size="mini" class="Warning" @click="toEdit" style="margin-left:30px">设置</el-button></div>
        </el-alert>
          <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="mini" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
              <el-table-column  prop="Name" label="姓名" >
                <template slot-scope="scope">
                  <div class="flexc-cen-x">
                    <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                    <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px">{{scope.row.Name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="Phone" label="手机号"  align="center">
              </el-table-column>
              <el-table-column  prop="CardName" label="会员卡"  align="center">
              </el-table-column>
              <el-table-column  prop="syNumber" label="卡类别"  align="center">
                <template slot-scope="scope">
   <span v-if="scope.row.CardType == 1">次卡（有期限）</span>
                    <span v-if="scope.row.CardType == 2">次卡（无限期）</span>
                    <span v-if="scope.row.CardType == 3">期限卡（不限次数）</span>
                    <span v-if="scope.row.CardType == 4">储蓄卡（无期限）</span>
                    <span v-if="scope.row.CardType == 5">期限卡（有期限）</span>
                </template>
              </el-table-column>
              <el-table-column  prop="OverdueTime" label="到期时间"  align="center">
              </el-table-column>
              <el-table-column  prop="CardDays" label="剩余数量(天)"  align="center">
              </el-table-column>
            <el-table-column align="center" label="操作" width="500"  fixed="right" >
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleDetail(scope.row)">续费</el-button>
                  <el-button size="mini" type="danger"  @click="handleChong(scope.row)">续费提醒</el-button>
              </template>
            </el-table-column>
          </el-table>
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </el-tab-pane>
      <el-tab-pane label="储蓄卡预警" name="2" v-if="isCard == 0">
        <el-form :inline="true" :model="formInline" >
            <el-form-item label="搜索：">
            <el-input size="mini" v-model="formInline.deptName" placeholder="输入姓名、手机号"></el-input>
            </el-form-item>
                         <el-form-item label="">
              <el-select  size="mini" v-model="MembersType">
                      <el-option
                            v-for="item in  membersList"
                            :key="item.ID"
                            :label="item.name"
                            :value="item.ID">
                    </el-option>
              </el-select>
             </el-form-item>
            <el-form-item label="">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-alert title="" type="warning" :closable="false">
        <div style="color:black">预警值： 剩余金额 ≤ <span class="Warning">{{Amount}}</span> 元           <el-button type="text" size="mini" class="Warning" @click="toEdit" style="margin-left:30px">设置</el-button></div>
        </el-alert>
        <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="mini" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
              <el-table-column  prop="Name" label="姓名" >
                <template slot-scope="scope">
                  <div class="flexc-cen-x">
                    <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                    <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px">{{scope.row.Name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="Phone" label="手机号"  align="center">
              </el-table-column>

              <el-table-column  prop="syNumber" label="卡类别"  align="center">
                <template slot-scope="scope">
                    <span>储蓄卡</span>
                </template>
              </el-table-column>
              <el-table-column  prop="czAmount" label="剩余金额(元)"  align="center">
              </el-table-column>
            <el-table-column align="center" label="操作" width="500"  fixed="right" >
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleDetail(scope.row)">续费</el-button>
                  <el-button size="mini" type="danger"  @click="handleChong(scope.row)">续费提醒</el-button>
              </template>
            </el-table-column>
          </el-table>
          <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

      </el-tab-pane>
      <el-tab-pane label="储次卡预警" name="3" v-if="isCard == 0">
        <el-form :inline="true" :model="formInline" >
            <el-form-item label="搜索：">
            <el-input size="mini" v-model="formInline.deptName" placeholder="输入姓名、手机号"></el-input>
            </el-form-item>
                         <el-form-item label="">
              <el-select  size="mini" v-model="MembersType">
                      <el-option
                            v-for="item in  membersList"
                            :key="item.ID"
                            :label="item.name"
                            :value="item.ID">
                    </el-option>
              </el-select>
             </el-form-item>
            <el-form-item label="">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-alert title="" type="warning" :closable="false">
        <div style="color:black">预警值：  剩余次数 ≤ <span class="Warning">{{CardNumber}}</span> 次       <el-button type="text" size="mini" class="Warning" @click="toEdit" style="margin-left:30px">设置</el-button></div>
        </el-alert>
          <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="mini" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
              <el-table-column  prop="Name" label="姓名" >
                <template slot-scope="scope">
                  <div class="flexc-cen-x">
                    <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                    <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px">{{scope.row.Name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="Phone" label="手机号"  align="center">
              </el-table-column>

              <el-table-column  prop="syNumber" label="卡类别"  align="center">
                <template slot-scope="scope">
                    <span>储次卡</span>
                </template>
              </el-table-column>

              <el-table-column  prop="syNumber" label="剩余数量(次)"  align="center">
              </el-table-column>
            <el-table-column align="center" label="操作" width="500"  fixed="right" >
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleDetail(scope.row)">续费</el-button>
                  <el-button size="mini" type="danger"  @click="handleChong(scope.row)">续费提醒</el-button>
              </template>
            </el-table-column>
          </el-table>
       <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="储蓄卡预警" name="4" v-if="isCard == 1">
        <el-form :inline="true" :model="formInline" >
            <el-form-item label="搜索：">
            <el-input size="mini" v-model="formInline.deptName" placeholder="输入姓名、手机号"></el-input>
            </el-form-item>
                         <el-form-item label="">
              <el-select  size="mini" v-model="MembersType">
                      <el-option
                            v-for="item in  membersList"
                            :key="item.ID"
                            :label="item.name"
                            :value="item.ID">
                    </el-option>
              </el-select>
             </el-form-item>
            <el-form-item label="">
                <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
        </el-form>
        <el-alert title="" type="warning" :closable="false">
          
       <div style="color:black">预警值：  剩余金额 ≤ <span class="Warning">{{Amount}}</span> 元 或 剩余天数 ≤ <span class="Warning">{{CardDays}}</span> 天         <el-button type="text" size="mini" class="Warning" @click="toEdit" style="margin-left:30px">设置</el-button></div>
        </el-alert>
        <el-table  :data="tableData" highlight-current-row v-loading="loading"  size="mini" element-loading-text="拼命加载中" style="width: 100%;margin-top:20px">
              <el-table-column  prop="Name" label="姓名" >
                <template slot-scope="scope">
                  <div class="flexc-cen-x">
                    <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                    <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                    <div style="margin-left:5px">{{scope.row.Name}}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column  prop="Phone" label="手机号"  align="center">
              </el-table-column>
              <el-table-column  prop="syNumber" label="卡类别"  align="center">
                <template slot-scope="scope">
                   <span v-if="scope.row.CardType == 1">次卡（有期限）</span>
                    <span v-if="scope.row.CardType == 2">次卡（无限期）</span>
                    <span v-if="scope.row.CardType == 3">期限卡（不限次数）</span>
                    <span v-if="scope.row.CardType == 4">储蓄卡（无期限）</span>
                    <span v-if="scope.row.CardType == 5">期限卡（有期限）</span>
                </template>
              </el-table-column>
              <el-table-column  prop="Amount" label="剩余金额(元)"  align="center">
              </el-table-column>
            <el-table-column align="center" label="操作" width="500"  fixed="right" >
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" @click="handleDetail(scope.row)">续费</el-button>
                  <el-button size="mini" type="danger"  @click="handleChong(scope.row)">续费提醒</el-button>
              </template>
            </el-table-column>
          </el-table>
      </el-tab-pane>
    </el-tabs>
    <!-- 搜索筛选 -->
 

    <!--列表-->

 


    <!-- 分页组件 -->

    <!-- 编辑界面 -->
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%">
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="margin-bottom:150px">
         <el-form-item label="姓名:" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="Phone">
          <el-input size="small" v-model="editForm.Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="会员编号:" prop="MemberCard">
          <el-input size="small" v-model="editForm.MemberCard"  placeholder="请输入会员编号" style="width: 215px"></el-input>
        </el-form-item>
          <el-form-item label="会员头像:" prop="HeadUrl">
                <div class="list-img-box cursor">
                  <div v-if="editForm.HeadUrl !== ''">
                    <img
                      :src="editForm.HeadUrl"
                      style="height: 100px;width:100px"
                      alt="图片"
                        @click="uploadPicture('HeadUrl')"
                    />
                  </div>
                  <div
                    v-else 
                    class="upload-btn"
                    style="height: 100px;width:100px"
                    @click="uploadPicture('HeadUrl')"
                  >
                    <!-- <i class="el-icon-plus" style="font-size: 30px"></i> -->
                 
                  <div class="flex-xy">
                       <i class="el-icon-plus coBlue" style="font-size: 25px"></i>
                        <span class="coBlue" style="font-size:13px;margin-top:-10px ">上传</span>
                  </div>

                    <!-- <span>封面设置</span> -->
                  </div>
                </div>
                <input
                  type="hidden"
                  v-model="editForm.HeadUrl"
                  placeholder="请添加头像"
                />
          </el-form-item>
         <el-form-item label="会员等级:" prop="LevelID">
            <el-select v-model="editForm.LevelID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList"
                  :key="item.ID"
                  :label="item.LevelName"
                  :value="item.ID">
                </el-option>
              </el-select>
           </el-form-item>
         <el-form-item label="性别:" prop="Sex">
          <el-radio-group v-model="editForm.Sex">
             <el-radio :label="1">男</el-radio>
             <el-radio :label="2">女</el-radio>
           </el-radio-group>
          <!-- <el-input size="small" v-model="editForm.LoginName" auto-complete="off" placeholder="请输入登录账号"></el-input> -->
        </el-form-item>
        <el-form-item label="出生日期:" prop="Birthday" size="small">
          <el-date-picker
            v-model="editForm.Birthday"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="登记日期:" prop="OpenTime" size="small">
          <el-date-picker
            v-model="editForm.OpenTime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地址:" prop="Address">
          <el-input size="small" placeholder="请输入地址" v-model="editForm.Address"  auto-complete="off" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="业务归属人:" prop="StaffID" v-if="title == '添加会员'">
            <el-select v-model="editForm.StaffID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in  personList"
                  :key="item.ID"
                  :label="item.Name"
                  :value="item.ID">
                </el-option>
            </el-select>
          
          <!-- <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input> -->
        </el-form-item>
      </el-form>

        <div class="demo-drawer__footer flex-r-x" style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
          style="margin-right:20px"
            size="small"
            type="primary"
       
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>

    <el-dialog
                  title="裁切封面"
                  :visible.sync="cropperModel"
                  width="1200px"
                  center
                >
                <cropper-image
                    :Name="cropperName"
                    @uploadImgSuccess="handleUploadSuccess"
                    ref="child"
                    :key="timer"
                  >
                  </cropper-image> 
    </el-dialog>
            <!--查看大封面-->
    <el-dialog title="查看大封面" :visible.sync="imgVisible" center>
              <img
                :src="imgName"
                v-if="imgVisible"
                style="width: 100%"
                alt="查看"
              />
    </el-dialog>
      <el-dialog title="修改密码" :visible.sync="passShow" width="40%">
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="密码" prop="deptNo">
          <el-input size="small" placeholder="请输入密码" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="topass()">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="续费提醒" :visible.sync="chongShow" width="40%" >
   
        <el-alert title="" type="warning" :closable="false">
        <div style="color:black">续费提醒将通过短信的形式发送给{{WZHYName}}</div>
        </el-alert>
        <div style="margin-top:15px">{{Smsinfo}}</div>
        <div class="flex-r-x" style="margin-top:20px;margin-right:20px">
            <div style="margin-right:10px">短信推送</div>
            <el-switch
            v-model="isSms"
           >
            </el-switch>
        </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="ADDmoney()">发送</el-button>
      </div>
    </el-dialog>
    <el-dialog title="次卡充值" :visible.sync="chongCi" width="40%">
      <el-form label-width="120px">
        <el-form-item label="充值次数" prop="number">
          <el-input size="small" placeholder="请输入充值次数" v-model="number"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="ADDCi()">充值</el-button>
      </div>
    </el-dialog>
    <el-dialog title="子账号" :visible.sync="ziShow" width="700px">
       <el-button size="mini" style="float:right;margin-top:-20px" type="primary" @click="editZi()">+ 添加</el-button>
    <el-table  :data="subList" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;margin-top:10px">
      <!-- <el-table-column align="center" type="selection" width="60">
      </el-table-column> -->
        <el-table-column  prop="Name" label="姓名" align="center" >
        </el-table-column>
        <el-table-column  prop="Phone" label="电话" align="center" >
          <!-- <template slot-scope="scope">
            <span v-if="scope.row.Type == 1">充值</span>
            <span v-if="scope.row.Type == 2">消费</span>
            <span v-if="scope.row.Type == 3">禁用</span>
            <span v-if="scope.row.Type == 4">解禁</span>
           
          </template> -->
        </el-table-column>
        <!-- <el-table-column  prop="addTime" label="操作时间" align="center" >
        </el-table-column> -->
        <el-table-column  prop="Note" label="备注" align="center" >
        </el-table-column>
        <el-table-column align="center" label="操作" width="200"  fixed="right" >
          <template slot-scope="scope">
            <el-button size="mini" @click="editZi(scope.row)">编辑</el-button>
             <el-button size="mini" type="info" @click="deleteSub(scope.row)">删除</el-button>
          </template>
        </el-table-column>

    </el-table>
     <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="ziShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="save()">保存</el-button>
        </div> -->
    </el-dialog>
    <el-dialog :title="subTitle" :visible.sync="editSub" width="40%" @click="closeDialog">
      <el-form label-width="120px" :model="form" :rules="rules1" ref="form">
        <el-form-item label="姓名" prop="Name">
          <el-input size="small" placeholder="请输入姓名" v-model="form.Name"  auto-complete="off"></el-input>
        </el-form-item>
                <el-form-item label="电话" prop="Phone">
          <el-input size="small" placeholder="请输入电话" type="number" v-model="form.Phone"  auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.Note" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editSub = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="sureSub('form')">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改预警值" :visible.sync="editShow" width="60%" @click="editShow = false">
                 <el-table
                 :key="timer"
                             :data="ListSetting"
                             tooltip-effect="dark"
                             border
                             stripe
                             style="width: 100%">
                            <el-table-column type="index" label="序号" align="center" width=""></el-table-column>
                             <el-table-column label="名称" prop="name"></el-table-column>
                            <el-table-column  label="有效值"  >
                                 <template slot-scope="scope">
                                  <span v-if="scope.row.isEdit=='0'">  {{scope.row.info}}</span>
                                  <el-input placeholder="请输入"  v-if="scope.row.isEdit=='1' && (scope.row.sType=='6' || scope.row.sType=='7' || scope.row.sType=='8'|| scope.row.sType=='9'|| scope.row.sType=='11'|| scope.row.sType=='12'|| scope.row.sType=='13'|| scope.row.sType=='14'|| scope.row.sType=='15')" v-model="scope.row.info" ></el-input>  
                                
                                  
                            </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="">
                            <template slot-scope="scope">
                             <el-button type="text" @click="editSeetingClick(scope.row)" v-if="(scope.row.Ison && scope.row.isEdit =='0' && scope.row.info !='')||scope.row.sType=='10'||scope.row.sType=='2' ||scope.row.sType=='5'" >修改</el-button>
                             <el-button type="primary" size="medium" @click="editsaverClick(scope.row)" v-if="scope.row.Ison && scope.row.isEdit=='1' ">保存</el-button>
                             <el-button type="default"  @click="editcancelClick(scope.row)" v-if="scope.row.Ison && scope.row.isEdit=='1' ">取消</el-button>
                             
                            </template>
                        </el-table-column>
                        </el-table>

    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";
import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
        value:false,
      imgVisible:false,
      cropperModel:false,
      direction: "ltr",
      passShow:false,
      typeList:[],
      DianList:[],
      timer:'',
      money:'',
      number:'',
      MembersType:1,
      ListSetting:[],
      membersList:[
        {
          ID:0,
          name:'全部'
        },
        {
          ID:1,
          name:localStorage.getItem('WZHYName')
        },
                {
          ID:2,
          name:'意向'+localStorage.getItem('WZHYName')
        },
     
      ],
      SelectStoresID:localStorage.getItem("StoresID"),
      chongCi:false,
      input:'',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      timer:'',
      cropperName:'',
         isSms:false,
      activeName:'0',
      StoreName:localStorage.getItem("StoresName"),
      tableData:[],
      editSub:false,
      Amount:'',
      ListRemindinfo:[],
      Pwd:'',
      id:'',
      isCard:localStorage.getItem('isCard'),
      personList:[],
      subList:[],
      subTitle:'',
      form:{
        Note:'',
        Name:'',
        Phone:'',
      },
      Smsinfo:'',
      editForm: {
        MemberCard:'',
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        HeadUrl:'',
        Sex:1,
        Address:'',
        Birthday:'2000-10-10',
        OpenTime:'',
        LevelID:'',
        StaffID:'',
        
 
      },
      Limits:[],
      Remindinfo:'',
      q1:false,
      q2:false,
      q3:false,
      ziShow:false,
      Note:'',
      // rules表单验证

      rules: {
          MemberCard: [{ required: true, message: '请输入会员编号', trigger: 'blur' }],
          LoginName: [{ required: true, message: '请输入登录账号', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          money: [{ required: true, message: '请输入余额', trigger: 'blur' }],
          ShopName: [{ required: true, message: '请输入商户名称', trigger: 'blur' }],
      },
  CardDays:'',
  CardNumber:'',
      rules1: {
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
          WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    editShow:false,
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
       if(localStorage.getItem('isAdmin') == 1){
          this.q1 = true
          this.q2 = true
          this.q3 = true
      }
 
      this.Limits = localStorage.getItem('Limits')
      this.Limits = this.Limits.split(',')
      this.Limits.forEach(items => {
            if(items == 841)
            this.q1  =true
            if(items == 842)
            this.q2 = true
            if(items == 843)
            this.q3 = true

      })

      this.getList()
      this.getType()

      this.getDianList()
      if(this.isCard == 0){
         this.activeName  = '2'
         this.getList2()
      }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        changeSwitch(val){
                let ison = 0;
               if(val.Ison){
                   ison =1;
               }else{
                   ison =0;
               }

              
               this.editSttingIson(val.ID , ison);
            }, editSttingIson(SttingID,Ison){

       this.tableLoading = true
       var data = {  SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          Ison:Ison
         }
     
      
        var that = this
         this.ajax('editSttingIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
              that.search();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
              // if()
                }else{
                 that.search();

                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });

                 }

      })

            },

            
            editSeetingClick(val){
                val.isEdit = '1';
                this.timer = new Date().getTime()
           
             },editsaverClick(val){
                
                 if(val.sType == '10'){
                this.editSttinginfodays(val.ID,this.Selecttimes,this.SelectDay);
               }else if(val.sType == '2'){
                this.editSttinginfodaysNew(val.ID,val.info,this.SelectDay);
               }else if(val.sType == '5'){
                this.editSttinginfodaysNew(val.ID,val.info,this.SelectDay);
               }else if(val.sType == '16'){
                 this.editSttinginfo(val.ID,this.Selecttimesmt);
               }
               else{
                 this.editSttinginfo(val.ID,val.info);
               }
                
              },editcancelClick(val){

                val.isEdit = '0';
                 this.timer = new Date().getTime()
                 
             }, editSttinginfo(SttingID,info){
                 this.tableLoading = true
                var data = {  SelectStoresID:this.SelectStoresID,
                    token: localStorage.getItem("token"),
                    StoresID:localStorage.getItem("StoresID"),
                    SttingID:SttingID,
                    info:info
                  }
              
      
         var that = this
         this.ajax('editSttinginfoNew.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
               that.search();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }, editSttinginfodaysNew(SttingID,info,days){
                 this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          info:info,
          days:days
         }
     
      
        var that = this
         this.ajax('editSttinginfodaysNew.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.search();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }, editSttinginfodays(SttingID,info,days){
                 this.tableLoading = true
       var data = {  SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SttingID:SttingID,
          info:info,
          days:days
         }
     
      
        var that = this
         this.ajax('editSttinginfodays.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.search();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             },
    toEdit(){
      this.editShow = true
        
     
          
    },
    xiugai(){
       for (let i = 0; i <this.ListSetting.length; i++) {
                        
                        if(this.ListSetting[i].Ison =='1'){
                        this.ListSetting[i].Ison = true;

                        }else{
                        this.ListSetting[i].Ison = false;

                        }
            this.ListSetting[i].isEdit = 0
      }
    },
    handleClick(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      }
    this.formInline.deptName = ''
        if(this.activeName == 0){
            this.getList()
        }
        if(this.activeName == 1){
            this.getList1()
        }
        if(this.activeName == 2){
            this.getList2()
        } else  if(this.activeName == 3){
            this.getList3()
        }if(this.activeName == 4){
            this.getList4()
        }
    },
    editZi(row){
        if(row){
          this.form = row
        this.subTitle = '修改子账号'
        } else {
          this.subTitle = '添加子账号'
        }
        this.editSub = true
    },
    handlZi(row){
      this.id = row.ID

     
        var that = this
        this.getSubList()
    },
    getSubList(){
       var data = { 
         SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          MembersID:this.id,
          }
          var that = this
       this.ajax('getListMembersSub.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.subList =res.data      
            }
      })
      this.ziShow = true
    },
    getDianList(){
       var data = { 
         SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.DianList =res.data      
            }
      })
},

  changedian(){
      this.pageparm ={
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      this.getType()
      this.getList()
    },
    uploadPicture(name) {
        this.timer = new Date().getTime()
      this.cropperName = name;
      this.cropperModel = true;
    },
    handleUploadSuccess(data) {
          this.cropperModel = false
          this.editForm.HeadUrl = data.url
 
  },
  handleDetail(row){
    localStorage.setItem("SelectStoresID", this.SelectStoresID);
    this.$router.push({ 

          path: `/vip/vipDetail/${row.ID}`,

      // path: '/vip/vipDetail', 
      //   params: {
      //     ID:row.ID
      //   }
      })

  },

    deleteSub(row){
    
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { 
            MembersSubID:row.ID,
            SelectStoresID:this.SelectStoresID,
            StoresID:localStorage.getItem("StoresID"),
            token: localStorage.getItem("token")
        }
        var that = this
        this.ajax('delMembersSub.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
            that.getSubList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
    },
        deleteUser(row){
        this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
         var data = { SelectStoresID:this.SelectStoresID,
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          MembersID:row.ID,
        
        }
        var that = this
        this.ajax('delMembers.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
              that.getType()
              that.getList()
              //  that.provinceList = res.data
            }

        })
        })
        .catch(() => {
            ;
        });
   
    },
  getType(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
  
                that.typeList = res.data
                //  loading.close();
          } 
       })
    
    },
    getList3(){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          SelectName:this.formInline.deptName,
          MembersType:this.MembersType,
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListYJMembersck.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.pageparm.total = res.allcount
                that.CardNumber = res.CardNumber
              // that.tableData.forEach(items => {
              //     items.OverdueTime = items.OverdueTime.replace(/\//g, '-')
              // });
              that.xiugai()
              that.ListSetting = res.ListSetting
                loading.close();
          } 

      })
  
    },
     getList4(){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          SelectName:this.formInline.deptName,
          MembersType:this.MembersType,
          CardType:4,
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListYJMembers.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                  that.tableData.forEach(items => {
                  items.OverdueTime = items.OverdueTime.replace(/\//g, '-')
              });
              that.ListSetting = res.ListSetting
                that.pageparm.total = res.allcount
                that.CardDays = res.CardDays
                that.CardNumber = res.CardNumber
                loading.close();
                that.xiugai()
          } 

      })
    },
    getList2(){
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          SelectName:this.formInline.deptName,
          MembersType:this.MembersType,
  
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListYJMemberscx.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.ListSetting = res.ListSetting
                that.pageparm.total = res.allcount
                that.Amount = res.Amount
           that.xiugai()
                loading.close();
          } 

      })
  
    },
    getList1(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          SelectName:this.formInline.deptName,
          MembersType:this.MembersType,
          CardType:3,
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListYJMembers.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                  that.tableData.forEach(items => {
                  items.OverdueTime = items.OverdueTime.replace(/\//g, '-')
              });
              that.ListSetting = res.ListSetting
                that.pageparm.total = res.allcount
                that.CardDays = res.CardDays
                that.Amount = res.Amount
                that.CardNumber = res.CardNumber
                loading.close();
                that.xiugai()
          } 

      })
  
    },
    getList(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          SelectName:this.formInline.deptName,
          MembersType:this.MembersType,
          CardType:1,
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListYJMembers.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.tableData.forEach(items => {
                  items.OverdueTime = items.OverdueTime.replace(/\//g, '-')
              });
              that.ListSetting = res.ListSetting
                that.pageparm.total = res.allcount
                that.CardDays = res.CardDays
                that.CardNumber = res.CardNumber
                that.xiugai()
                loading.close();
          } 

      })
  
    },
    handlePassword(row){
      this.editForm.ManageLoginID = row.ID
      this.Pwd = ''
      this.passShow = true

    },
    handleCi(row){
     this.id = row.ID
      this.chongCi = true
      this.number = ''
      this.Note=''
    },
    handleChong(val){
       this.Remindinfo =val;
                    this.ListRemindinfo =[];
                    var allcount ="";
                    if(val.CardType=='1'){
                        allcount = val.CardNumber +'次' +' （'+val.CardDays+')'+'天';
                    }else if(val.CardType=='2'){
                       allcount = val.CardNumber +'次' ;
                    }else if(val.CardType=='3'){
                       allcount = val.CardDays +'天' ;
                    }else if(val.CardType=='4'){
                       allcount = val.Amount +'元' ;
                    }else if(val.CardType=='5'){
                       allcount = val.Amount +'元' ;
                    }
                   this.Remindinfo.allcount = allcount;
                    var OverdueTime ="";
                     if (val.CardType === '1') {
                        OverdueTime = val.OverdueTime;
                        } else if (val.CardType === '3') {
                           OverdueTime = val.OverdueTime
                        } else if (val.CardType === '5') {
                           OverdueTime = val.OverdueTime
                        } else  {
                        OverdueTime ="";
                        } 
                    if(this.isCard == 0 && this.activeName == '2'){
                      val.CardName = '储蓄卡'
                    }
                    if(this.isCard == 0 && this.activeName == '3'){
                      val.CardName = '储次卡'
                    }
                    var dao = ''
                    if(val.CardType  == 1 || val.CardType  == 3 ||val.CardType  == 5 )
                     dao = '即将到期，'
                  if(val.CardType  == 2 || (this.isCard == 0 && this.activeName == '3') )
                     dao = '次数不足，'
                  if(val.CardType  == 4 || (this.isCard == 0 && this.activeName == '2') )
                     dao = '金额不足，'
                      this.Smsinfo = '【预约小宝】'+val.Name+'您好，您的'+val.CardName + dao +'请及时续费('+this.StoreName+')';
                       this.ListRemindinfo.push({
                            MembersID:val.ID,
                            MembersName:val.Name,
                            CardNum:val.CardNum,
                            CardName:val.CardName,
                            allcount:allcount,
                            OverdueTime:OverdueTime
                         })
      // this.id = row.ID
      this.chongShow = true

    },
    ADDCi(){
         var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.id,
          syNumber:this.number,
          Note:this.Note,

      }
        var that = this
        this.ajax('editMemberssyNumber.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
     
               that.tableData = res.data
     
               that.$message({
                            type: "success",
                            message: "充值成功",duration:2000,
                  });
            that.chongCi = false
            that.getList()
          } 

      })
    },
    ADDmoney(){
       let ListRemindInfo = JSON.stringify(this.ListRemindinfo);
        var isSmson =0;
                  if(this.isSms){
                        isSmson =1;
                  }else{
                      isSmson =0;
                  }
         var data = { 
           SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          ListRemindInfo:ListRemindInfo,
          isSMS:isSmson

      }
        var that = this
        this.ajax('ContractToRemind.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
     
                that.tableData = res.data
     
               that.$message({
                            type: "success",
                            message: "发送成功",duration:2000,
                  });
            that.chongShow = false
           that.handleClick()
          } 

      })
    },
    // 获取公司列表

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      if(this.activeName == 0){
            this.getList()
        }
        if(this.activeName == 1){
            this.getList1()
        }
        if(this.activeName == 2){
            this.getList2()
        } else  if(this.activeName == 3){
            this.getList3()
        }
    },
    // 搜索事件
    search() {
      // this.getdata(this.formInline)
       if(this.activeName == 0){
            this.getList()
        }
        if(this.activeName == 1){
            this.getList1()
        }
        if(this.activeName == 2){
            this.getList2()
        } else  if(this.activeName == 3){
            this.getList3()
        }  if(this.activeName == 4){
            this.getList4()
        }
    },
    //显示编辑界面
    handleEdit: function(row) {
      
     
      if (row != undefined && row != 'undefined') {
        this.title = '修改会员'
        this.editForm =row
        this.editForm.Sex = Number(this.editForm.Sex) 
         this.editFormVisible = true
      } else {
          
            
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = year + '-' + month + '-' + day;
          this.editForm.OpenTime = nowDate
           this.title = '添加会员'
     this.getVIpCard()
        //  this.editForm.ManageLoginID = ''
        // this.editForm.LoginName = ''
        // this.editForm.Phone= ''
        // this.editForm.Name= ''
        // this.editForm.ShopName= ''
        // this.editForm.pwd=''
        // this.editForm.money=' '

      }
    },
    getVIpCard(){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
         
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getMemberCode.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                // console.log(res.data)
               that.editForm={
                LoginName:"",
                Phone:"",
                Name:"",
                pwd:"",
                money:"",
                ShopName:"",
                HeadUrl:'',
                Sex:1,
                Address:'',
                Birthday:'2000-10-10',
                OpenTime:'',
                LevelID:'',
                StaffID:'',
                MemberCard:res.data

            }
              
                 that.editFormVisible = true
       
          } 

      })
    },
    sureSub(editData){
      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.subTitle == '添加子账号'){
              var data = this.form
                data.MembersID = this.id
                data.SelectStoresID  = this.SelectStoresID 
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                var that = this
                 this.ajax('addMembersSub.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "添加成功",duration:2000,
                          });
                        that.editSub = false
                        that.getSubList()
                        // that.get()
                      }

                  })
            } else {
                 var data = this.form
                data.MembersSubID = this.form.ID
                data.SelectStoresID  = this.SelectStoresID 
                data.token=localStorage.getItem("token")
                data.StoresID=localStorage.getItem("StoresID")
                var that = this
                 this.ajax('editMembersSub.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "修改成功",duration:2000,
                          });
                        that.editSub = false
                        that.getSubList()
                        // that.get()
                      }

                  })
            }
          } 
        })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          var that = this
            var data = this.editForm
            data.SelectStoresID  = this.SelectStoresID 
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
            if(this.title == '添加会员'){
              this.ajax('addMembers.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                          });
                        that.editFormVisible = false
                        that.getList()
                      }

                  })

               

            }else {
              data.MembersID = this.editForm.ID
             this.ajax('editMembers.aspx',JSON.stringify(data),"POST",function(res){
                     if (res.orsuccess == "1") {
                              that.$message({
                                    type: "success",
                                    message: "修改成功",duration:2000,
                                  });
                                  that.editFormVisible = false
                                  that.getList()
                                }                                 

                    })         

            }
        } else {
          return false
        }
      })
  
    
    },

    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false,
      this.chongShow = false,
      this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/vip/renew.vue